import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate } from 'react-intl';
import { Link } from 'react-router-dom';

import Heading from '@bibliocommons/heading';
import { Table, TableHeader, TableHeading, TableBody, TableRow, TableCell } from '@bibliocommons/table';

import { ROUTE } from 'app/constants/AdminBrowseConstants';
import { browseHomePageShape } from 'app/shapes/browse';

const AdminBrowseHomePage = ({ browseHomePages }) => {
  return (
    <div className="cp-admin-browse-home-page container">
      <Heading size="large" tagName="h1" variant>
        Browse Home
      </Heading>

      <Table>
        <TableHeader>
          <TableHeading>Name</TableHeading>
          <TableHeading>Creator</TableHeading>
          <TableHeading>Language</TableHeading>
          <TableHeading>Last updated</TableHeading>
          <TableHeading>Last updated by</TableHeading>
          <TableHeading>Actions</TableHeading>
        </TableHeader>
        <TableBody>
          {browseHomePages.map(browseHomePage => {
            const { browseHomePageId, createdBy, localeCode, name, updatedAt, updatedBy } = browseHomePage;

            return (
              <TableRow key={browseHomePageId}>
                <TableCell>{name}</TableCell>
                <TableCell>{createdBy}</TableCell>
                <TableCell>{localeCode}</TableCell>
                <TableCell>
                  <FormattedDate value={updatedAt} />
                </TableCell>
                <TableCell>{updatedBy}</TableCell>
                <TableCell>
                  <Link
                    dataKey={`${ROUTE.ADMIN_BROWSE_HOME_EDIT}/${browseHomePageId}`}
                    to={`${ROUTE.ADMIN_BROWSE_HOME_EDIT}/${browseHomePageId}`}
                  >
                    Edit
                  </Link>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

AdminBrowseHomePage.propTypes = {
  browseHomePages: PropTypes.arrayOf(browseHomePageShape).isRequired
};

export default AdminBrowseHomePage;
